export default function (context, val) {
    context.state.list.filter(i => {
        return i.code === val.agreement.code;
    })[0].date = val.value;
}